<template lang="html">

    <section class="energia-alt sec-foto metal">
      <img class="w-100" src="/static/img/bkg/bkg-energia-alt.webp" :alt="$t('catalogo.alt_images.pila_hidrogeno')">
      <div class="container waypoints flex row-reverse justify" data="fadeInRight">
        <div class="col-50 text-container">
          <a target="_blank" href="http://www.ajusath.es/"></a>
          <h3 class="title-18">{{$t('catalogo.ajusa_th.intro')}}</h3>
          <h4 class="title title-52">{{$t('catalogo.ajusa_th.titulo')}}</h4>
          <div v-html="$t('catalogo.ajusa_th.texto')"></div>
          <p class="go">{{$t('catalogo.ajusa_th.boton')}}<i class="fa-sharp fa-solid fa-arrow-right-long" ></i></p>
        </div>
      </div>
    </section>
</template>

<script lang="js">
  export default  {
    name: 'banner-ajusa-th',
    props: [],
    mounted() {

    },
    data() {
      return {
        showAjusath : false
      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped>
  .banner-ajusa-th {

  }
</style>



// WEBPACK FOOTER //
// src/components/parts/banner-ajusa-th.vue